/** Le fasi archiviate conservano date e collegamenti per consultazione, non per pianificare. */
export function isArchivedGanttTask(task: { nome: string }): boolean {
  return task.nome.startsWith("[STORICO]");
}
